import styled from "@emotion/styled";
import {
  GelButton,
  GelCaption,
  GelContainerLite,
  GelHeading3,
  GelList,
  GelListItem,
  GelIcon,
  GelBoxLayout,
  GelModal,
  GelLink,
  GelParagraph,
  GelScreenDetectorContext,
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import Avatar from "components/components/Avatar";
import Blockquote from "components/components/Blockquote";
import ModuleContainer from "components/components/ModuleContainer";
import { caseStudies } from "data/case-studies";
import React, { Suspense, useEffect } from "react";
import { Navigation, Scrollbar } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

const HomeCarousel = ({ caseStudy }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { isLargerThanSmScreen, screen } = React.useContext(GelScreenDetectorContext);
  const [active, setActive] = React.useState(0);

  useEffect(() => {
    if (caseStudy !== undefined) {
      setActive(caseStudy);
    } else setActive(0);
  }, [caseStudy]);

  const onNext = () => {
    const items = caseStudies.length;
    const currentItem = active;
    const nextItem = currentItem + 1;

    if (nextItem < items) {
      setActive(nextItem);
    } else setActive(0);
  };

  return (
    <ModuleContainer
      id="caseStudy"
      marginBottom={getGelTokens().global.sizeBaseX10}
      paddingTop={getGelTokens().global.sizeBaseX16}
      paddingBottom={getGelTokens().global.sizeBaseX10}
    >
      <GelContainerLite fixed>
        <GelHeading3
          textAlign="center"
          paddingTop={56}
          marginBottom={getGelTokens().global.sizeBaseX4}
        >
          Human stories behind skin cancer
        </GelHeading3>
        <GelParagraph textAlign="center" marginBottom={getGelTokens().global.sizeBaseX8}>
          Hear from Australians who have personally experienced skin cancer as they share their
          story with us. Each of their stories are powerful and unique. Yet, there is a consistent
          theme, skin cancer does not discriminate, so, prevention is better than a cure. Regularly
          checking your own skin can help to maximise the chance of detecting skin cancer early and
          greatly increases the chance of successful treatment.
        </GelParagraph>
      </GelContainerLite>
      {/* Insert carousel */}
      <GelContainerLite fixed>
        <SSwiper
          slidesPerView={"auto"}
          spaceBetween={32}
          modules={[Scrollbar, Navigation]}
          navigation={true}
          initialSlide={active}
          allowTouchMove={false}
        >
          {caseStudies.map((item, i) => {
            return (
              <SSlide key={i} data-hash={i}>
                <Avatar
                  name={item.name}
                  label={item.name}
                  description={item.description}
                  active={i === active}
                  imageName={item.image}
                  _onClick={() => setActive(i)}
                />
              </SSlide>
            );
          })}
        </SSwiper>
      </GelContainerLite>
      {/* Quote */}
      <GelContainerLite fixed>
        <SContentContainer screen={isLargerThanSmScreen(screen)}>
          <div className="first-item">
            <GelHeading3>{caseStudies[active].name.split(" ")[0]}'s Story</GelHeading3>
            <Blockquote>{caseStudies[active].quote}</Blockquote>
          </div>
          {isLargerThanSmScreen(screen) ? (
            <div className="second-item">
              <SStory>
                {caseStudies[active].story.split(/\n/).map((p, i) => (
                  <GelParagraph key={i} marginBottom={getGelTokens().global.sizeBaseX4}>
                    {p}
                  </GelParagraph>
                ))}
              </SStory>

              <GelButton secondary medium iconRight="ArrowRight" onClick={onNext}>
                Next story
              </GelButton>
            </div>
          ) : (
            <GelButton secondary medium iconRight="Plus" onClick={() => setOpenModal(true)}>
              Read story
            </GelButton>
          )}
        </SContentContainer>
        <GelCaption marginBottom={getGelTokens().global.sizeBaseX4}>
                  *Bookings are made through Health Direct,a government-funded services. Visit our Health Direct
          <GelLink
            inline
            onClick={() =>
              window.open(
                "https://www.tal.com.au/about-us/our-contribution/our-customers/health/tal-spotchecker/faqs"
              )
            }
          >
           Frequently Asked Questions 
                  </GelLink>page for more
                  information.
        </GelCaption>
        <GelList ordered>
          <GelListItem>
            <GelCaption>
                Keratinocyte Cancer Incidence in Australia: a review of population-based incidence trends and estimates of lifetime risk - March 2022, Volume 31, Issue 1. Accessed on 30 October 2024 from   {" "}
              <GelLink
                href="https://www.phrp.com.au/issues/march-2022-volume-32-issue-1/keratinocyte-cancer-incidence-in-australia-a-review-of-population-based-incidence-trends-and-estimates-of-lifetime-risk/"
                target="_blank"
                          > Keratinocyte cancer incidence in Australia: a review of population-based incidence trends and estimates of lifetime risk - March 2022, Volume 32, Issue 1 | PHRP
              </GelLink>
            </GelCaption>
          </GelListItem>
          <GelListItem>
            <GelCaption>
             Cancer Council Guide, "Understanding Skin Cancer". Accessed on 30 October 2024 from  {" "}
            <GelLink
                href="https://www.cancer.org.au/assets/pdf/understanding-skin-cancer-booklet"
                target="_blank"
                > https://www.cancer.org.au/assets/pdf/understanding-skin-cancer-booklet
            </GelLink>
            </GelCaption>
          </GelListItem>
          <GelListItem>
            <GelCaption>
            Cancer Council Guide, "Understanding Melanoma". Access on 31st October 2024 from {" "} 
            <GelLink
                href="https://www.cancer.org.au/assets/pdf/understanding-melanoma-cancer-booklet"
                target="_blank"
            > https://www.cancer.org.au/assets/pdf/understanding-melanoma-cancer-booklet
            </GelLink>
            </GelCaption>
          </GelListItem>
          <GelListItem>
                <GelCaption>Cancer Council, "Basal and Squamous Cell Carcinoma, Non-melanoma skin cancer". Accessed on 30 October 2024 from {" "} 
                    <GelLink
                        href="https://www.cancer.org.au/cancer-information/types-of-cancer/non-melanoma-skin-cancer"
                        target="_blank"
                    > Basal and Squamous Cell Carcinoma | Non-melanoma skin cancer | Cancer Council
                    </GelLink>
            </GelCaption>
          </GelListItem>
          <GelListItem>
            <GelCaption>The survey was conducted by Edentify Pty Ltd on behalf of TAL, in October 2024, with a sample of 1,000 respondents in Australia aged 18-65+ years old.</GelCaption>
        </GelListItem>
        <GelListItem>
                      <GelCaption>Cancer Council, "Check for signs of skin cancer". Accessed 30 October 2024 from {" "}
                <GelLink
                   href="https://www.cancer.org.au/cancer-information/causes-and-prevention/sun-safety/check-for-signs-of-skin-cancer"
                    target="_blank"
                          > Check for signs of skin cancer | Cancer Council
                </GelLink>
            </GelCaption>
        </GelListItem>
          {/* <GelListItem>
            <GelCaption>
              Ferlay J, Soerjomatram I, Ervik M, Dikshit R, Eser S, Mathers C, Rebelo M, Parkin D,
              Forman D, Bray F. Globocan 2012 V1.0, Cancer incidence and mortality worldwide: Iarc
              Cancerbase No. 11. Iarc, World Health Organisation, 2013.{" "}
            </GelCaption>
          </GelListItem> */}
         
        </GelList>
              {/*<GelBoxLayout
          space={["auto", 1]}
          gap="small"
          distribution="start"
          alignment="start"
          marginTop={12}
        >
          <GelIcon name="ChevronUp" inline width={getGelTokens().global.sizeBaseX4}></GelIcon>
          <GelCaption>
            Staples MP, Elwood M, Burton RC, Williams JL, Marks R, Giles GG.{" "}
            <GelLink
              href="https://aus01.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.ncbi.nlm.nih.gov%2Fpubmed%2F16398622&data=05%7C01%7CKerrie.Hui%40tal.com.au%7Ceab72f8ad0ce4550498508dbeee12a53%7Cfedfd771b82e47b1a705959f02fe7ded%7C0%7C0%7C638366423084372693%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=Kh%2Fw89MElBcPOTMNwKeucpinVUU7vLpWQNMlhEVtgqA%3D&reserved=0"
              target="_blank"
            >
              Non-melanoma skin cancer in Australia: The 2022 National Survey and Trends since 1985{" "}
            </GelLink>
            Med J Aust 2006 Jan 2, 184 (1):6-10
          </GelCaption>
        </GelBoxLayout>*/}

        <GelCaption condensed marginTop={getGelTokens().global.sizeBaseX8}>
          The information contained in this webpage is not a substitute for advice from a qualified
          medical or other health professional. It is not intended to diagnose, treat, cure or
          prevent any health problem. Always consult your medical practitioner or other health
          professional in relation to any medical issue or concern. While all care has been taken to
          ensure that the information provided is accurate and complete at the date of publication,
          neither TAL nor its employees accept liability for any loss or damage caused as a result
          of reliance on the information.
        </GelCaption>
      </GelContainerLite>

      <GelModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={caseStudies[active].name}
      >
        <Suspense fallback={<div>Loading</div>}>
          {caseStudies[active].story.split(/\n/).map((p, i) => (
            <GelParagraph key={i} marginBottom={getGelTokens().global.sizeBaseX4}>
              {p}
            </GelParagraph>
          ))}
        </Suspense>
      </GelModal>
    </ModuleContainer>
  );
};

export default HomeCarousel;

const SSlide = styled(SwiperSlide)({
  width: "fit-content",
});

const SSwiper = styled(Swiper)`
  .swiper-button-next,
  .swiper-button-prev {
    background-color: ${getGelTokens().button.buttonPrimaryBackgroundColor};
    height: ${getGelTokens().button.buttonMediumHeight}px;
    width: ${getGelTokens().button.buttonMediumHeight}px;
    border-radius: ${getGelTokens().button.buttonMediumBorderRadius}px;

    &:hover {
      background-color: ${getGelTokens().button.buttonPrimaryHoverBackgroundColor};
    }

    &:after {
      font-size: ${getGelTokens().button.buttonMediumIconSize}px;
      color: ${getGelTokens().button.buttonPrimaryIconColor};
    }
  }

  .swiper-button-disabled {
    opacity: 1;
    background-color: ${getGelTokens().button.buttonPrimaryDisabledBackgroundColor};

    &:after {
      color: ${getGelTokens().button.buttonPrimaryDisabledIconColor};
    }
  }
`;

const SContentContainer = styled.div(
  {
    height: "fit-content",
    overflow: "hidden",
    display: "flex",
    alignItems: "start",
    paddingTop: getGelTokens().global.sizeBaseX12,
    marginBottom: getGelTokens().global.sizeBaseX10,

    ".first-item": {
      flex: 1,
    },

    ".second-item": {
      flex: 2,
    },
  },

  (props) => ({
    flexWrap: props.screen ? "nowrap" : "wrap",
    flexDirection: props.screen ? "row" : "column",
    gap: props.screen ? getGelTokens().global.sizeBaseX14 : 0,
  })
);

const SStory = styled.div({
  overflowY: "scroll",
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  height: 400,
  marginBottom: getGelTokens().global.sizeBaseX8,
  borderBottom: `1px solid ${getGelTokens().global.themeColorBorderDefault}`,
  boxShadow: `2px 2px 4px 0px rgba(0,0,0,0.12)`,
});
